import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUi } from './ui.interfaces';

export const selectUiState = createFeatureSelector<IUi>('ui');

export const getIsLoginCheckComplete = createSelector(
  selectUiState,
  (ui) => ui.isLoginCheckComplete
);

export const getSubdomain = createSelector(selectUiState, (ui) => ui.subdomain);

export const getIsLotOrUnit = createSelector(selectUiState, (ui) => ui.isLot);

export const getStrataPlanNumber = createSelector(
  selectUiState,
  (ui) => ui.strataPlanNumber
);

export const getStrataPlanNumberFriendlyName = createSelector(
  selectUiState,
  (ui) => ui.strataPlanNumberFriendlyName
);

export const getLots = createSelector(selectUiState, (ui) => ui.lotUnits);

export const getIsLoggedIn = createSelector(
  selectUiState,
  (ui) => ui.isLoggedIn
);

export const approverGetUserLogin = createSelector(
  selectUiState,
  (ui) => ui.isApprover
);

export const getTerms = createSelector(
  selectUiState,
  (ui) => ui.siteSettings?.userAccountTerms
);

export const getSiteSettings = createSelector(
  selectUiState,
  (ui) => ui.siteSettings
);

export const getActionStatus = createSelector(
  selectUiState,
  (ui) => ui.actionStatus
);

export const getRoles = createSelector(
  selectUiState,
  (ui) => ui.siteSettings?.roles ?? []
);

export const getUsePetRegistry = createSelector(
  getSiteSettings,
  (ui) => ui.usePetRegistry
);

export const getUseVehicleRegistry = createSelector(
  getSiteSettings,
  (ui) => ui.useVehicleRegistry
);
